import { render, staticRenderFns } from "./Contect.vue?vue&type=template&id=28594253&scoped=true&"
import script from "./Contect.vue?vue&type=script&lang=js&"
export * from "./Contect.vue?vue&type=script&lang=js&"
import style0 from "./Contect.vue?vue&type=style&index=0&id=28594253&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28594253",
  null
  
)

export default component.exports